import { first } from 'lodash';

var Bootstrap = Esk.Helper.Bootstrap;

var PASSWORD_FIELD_ID = "Password",
  PASSWORD_FIELD_REF = "Password",
  PASSWORD_FIELD_NAME = "password";

var PASSWORD_CONFIRM_FIELD_ID = "PasswordConfirm",
  PASSWORD_CONFIRM_FIELD_REF = "PasswordConfirm",
  PASSWORD_CONFIRM_FIELD_NAME = "confirmPassword";

var TERMS_FIELD_ID = "Terms",
  TERMS_FIELD_REF = "Terms",
  TERMS_FIELD_NAME = "terms";

var GO_TO_LOGIN_ID = "GoToLogin";
var Link = ReactRouter.Link;
var RoutePath = Esk.Constants.RoutePath;

var FORM_REF = "Form";

var validationRules = require('./validation');

var WithError = require('./../../../utils/mixins/withError');


var ResetPasswordAction = React.createClass({

  propTypes: {
    onSubmit: React.PropTypes.func,
    invalidToken: React.PropTypes.bool
  },

  componentDidMount(){
    var {t} = this.props;
    var form = this.refs[FORM_REF];
    $(form).validate(validationRules(t));

    // TODO: hack; i18n editor won't extract this string from other methods of the class
    t("Reset Password");
  },

  render(){
    return (
      this._getContent()
    );
  },

  _getError(){
    var { error, invalidToken } = this.props;

    if (!error && !invalidToken) {
      return null;
    }

    var errorMessage = invalidToken
      ? Esk.Constants.ConstantsHelper.Error.ACCOUNT_RESET_PASSWORD_FAILURE.resetPasswordValidation
      : first(error);

    return <Esk.Helper.Ui.ErrorMessage errorMessage={errorMessage}/>;
  },

  _getContent() {
    var {t, invalidToken} = this.props;

    if (invalidToken) {
      return (
        <div className="well no-padding">
          <form className="smart-form client-form" ref={FORM_REF}
                onSubmit={this._onSaveHandler}>
            <header>
              {t("Reset Password")}
            </header>

            <fieldset>
              {this._getError()}
            </fieldset>

            <Bootstrap.FormActionsAccount>
              <Link to={RoutePath.ROUTE_LOGIN} className="smart-form-link">
                {t("Go to login")}
              </Link>
            </Bootstrap.FormActionsAccount>
          </form>
        </div>
      );
    }

    return (
      <div className="well no-padding">
        <h2 className="esk-security-page-heading">
          {t('Please enter the password you want to set for your account below.')}
        </h2>
        <form className="smart-form client-form" ref={FORM_REF}
              onSubmit={this._onSaveHandler}>
          <header>
            {t("Reset Password")}
          </header>

          <fieldset>

            {this._getError()}

            <Bootstrap.FormGroupAccount
              elementId={PASSWORD_FIELD_ID}
              label={this._getFieldLabel(PASSWORD_FIELD_ID)}
            >
              <Esk.Helper.InputTooltip
                helpText={Esk.Constants.ConstantsHelper.Message.Account.passwordTooltip}>
                <input id={PASSWORD_FIELD_ID}
                       type="password"
                       className="form-control"
                       ref={PASSWORD_FIELD_REF}
                       name={PASSWORD_FIELD_NAME}
                       placeholder={t('Password')}
                />
              </Esk.Helper.InputTooltip>
            </Bootstrap.FormGroupAccount>

            <Bootstrap.FormGroupAccount
              elementId={PASSWORD_CONFIRM_FIELD_ID}
              label={this._getFieldLabel(PASSWORD_CONFIRM_FIELD_ID)}
            >
              <input id={PASSWORD_CONFIRM_FIELD_ID}
                     type="password"
                     className="form-control"
                     ref={PASSWORD_CONFIRM_FIELD_REF}
                     name={PASSWORD_CONFIRM_FIELD_NAME}
                     placeholder={t('Confirm Password')}
              />
            </Bootstrap.FormGroupAccount>

          </fieldset>

          <Bootstrap.FormActionsAccount>
            <Link to={RoutePath.ROUTE_LOGIN} className="smart-form-link">
              {t("Go to login")}
            </Link>
            <button className="btn btn-primary"
                    type="submit">{t("Reset Password")}</button>
          </Bootstrap.FormActionsAccount>
        </form>
      </div>
    );

  },

  _getFieldLabel(fieldId){
    var {t} = this.props;
    switch (fieldId) {
      case PASSWORD_FIELD_ID:
        return t("Password");
      case PASSWORD_CONFIRM_FIELD_ID:
        return t("Confirm password");
      case TERMS_FIELD_ID:
        return <a href={Esk.Config.termsAndConditionsUrl}
                  target="_blank">{t("Terms and conditions")}</a>;
      case GO_TO_LOGIN_ID:
        return t("Go to login");
    }

    return "";
  },

  _onSaveHandler(e){
    e.preventDefault();
    var {onSubmit} = this.props;
    if (!onSubmit) return;

    var form = this.refs[FORM_REF];
    if (!$(form).valid()) return;

    var data = {};
    data.password = this.refs[PASSWORD_FIELD_REF].value;
    data.confirmPassword = this.refs[PASSWORD_CONFIRM_FIELD_REF].value;
    onSubmit(data);
  }
});


module.exports = WithError(ResetPasswordAction);
